// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3FZcF","Logo":"Toolbar_Logo__Z-R4b","DesktopOnly":"Toolbar_DesktopOnly__3ZF8d"};